import React from 'react';
import { Field } from 'react-final-form';
import { RenderDropdown } from 'forms';

import { SPRAY_EVENT_APPLICATION_TYPE_DROPDOWN_OPTIONS } from 'services/sprayEvents/constants';

interface Props {
    name: string;
    label?: string;
    validate?: any;
    nullOnUnmount?: boolean;
    placeholder?: string;
    disabled?: boolean;
}

export default function ApplicationTypeDropdown(
    props: Props
): React.ReactElement {
    const {
        name,
        label = 'Application Type',
        validate,
        nullOnUnmount = false,
        placeholder,
        disabled = false
    } = props;

    return (
        <Field
            component={RenderDropdown as any}
            subscription={{
                value: true,
                touched: true,
                error: true
            }}
            name={name}
            label={label}
            fluid
            search
            selection
            clearable
            selectOnBlur={false}
            validate={validate}
            options={SPRAY_EVENT_APPLICATION_TYPE_DROPDOWN_OPTIONS}
            nullOnUnmount={nullOnUnmount}
            placeholder={placeholder}
            disabled={disabled}
        />
    );
}
